import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

const state = {
  userDevice: '',
  platformType: '',
  IOSDeviceVersion: false,
  isIPhone: false
};

export default {
  state,
  mutations,
  actions,
  getters
};
